import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { min } from 'lodash';

@Component({
  selector: 'app-numeric-cell-renderer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="text-right pr-20">
      {{ displayValue }}
    </div>
  `,
})
export class NumericCellRendererComponent implements CellRenderer<any, any> {
  @Input() params!: CellRendererParams<number, any>;

  get displayValue(): string {
    const value = this.params?.value ?? 0;
    return this.params?.valueFormatted ?? value?.toLocaleString('es-HN', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }) ?? '-';
  }
}
